<template>
    <div>
        <div class="banner">
            <div class="headerReplacementBasicInfo"></div>
            <div class="banner-text">
                <h4><b>{{ $t('shareSubscription.pageTitle') }}</b></h4>
                <div class="breadcrumb">
                    <span>
                        <router-link :to="$t('shareSubscription.breadcrumb[0].to')" class="pe-auto">
                            {{ $t('shareSubscription.breadcrumb[0].text') }}
                        </router-link>
                    </span>
                    <span class="separator"></span>
                    <span>{{ $t('shareSubscription.breadcrumb[1].text') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('shareSubscription.breadcrumb[2].text') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <BasicInfoTabMenu />
            </div>

            <table class="table mb-5">
                <thead>
                    <tr class="table-secondary">
                        <th scope="col"><b>{{ $t('shareSubscription.tableTitle') }}</b></th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                        <td>{{ item.notification_name }}</td>
                        <td class="text-end">
                            <a :href="item.notification_url" target="_blank" class="text-decoration-none">
                                <p class="card-text text-secondary">
                                    <small class="text-muted">
                                        <i class="fa-solid fa-download"></i> {{ $t('shareSubscription.downloadText') }}
                                    </small>
                                </p>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
  
<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import store from "@/store";
import { GET_NOTIFICATION_DATA } from "../../store/actions.type";

export default {
    name: 'MajorShareholders',
    components: {
        BasicInfoTabMenu,
    },
    data() {
        return {
            list: [],
            isLoading: false,
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    watch: {
        '$i18n.locale'(newLang, oldLang) {
            this.init(); // โหลดใหม่เมื่อเปลี่ยนภาษา
        }
    },
    methods: {
        async init() {
            this.isLoading = true;
            const lang = this.$i18n.locale || 'th';
            this.list = await store.dispatch(GET_NOTIFICATION_DATA, lang);
            this.isLoading = false;
        }
    }
}
</script>

  
